import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MensajerosRegistroComponent } from './mensajeros/mensajeros-registro/mensajeros-registro.component';
import { TerminosCondicionesComponent } from './terminos-condiciones/terminos-condiciones.component';
import { Version10Component } from './terminos-condiciones/version10/version10.component';
import { TiendasMovilComponent } from './tiendas-movil/tiendas-movil.component';
import { RegistroExitosoComponent } from './tiendas/registro/registro-exitoso/registro-exitoso.component';
import { RegistroComponent } from './tiendas/registro/registro.component';

const routes: Routes = [
  { path: 'registro-comercio', component: RegistroComponent },
  { path: 'registro-comercio/:id', component: RegistroComponent },
  { path: 'registro-exitoso', component: RegistroExitosoComponent },
  { path: 'registro-mensajero', component: MensajerosRegistroComponent },
  { path: 'terminos-condiciones', component: TerminosCondicionesComponent },
  { path: 'terminos-condiciones-version-1.0', component: Version10Component },
  { path: 'registro-movil', component: TiendasMovilComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompaniaRoutingModule { }
